import { useEffect, useState } from "react";
import { canNotGetMergeLinkTestCookie, setAgentHandlerLinkTestCookie } from "../Helpers";

const use3PCookieDisabled = () => {
  const [canNotGetCookies, setCanNotGetCookies] = useState<boolean | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setAgentHandlerLinkTestCookie();
      setCanNotGetCookies(canNotGetMergeLinkTestCookie());
    }, 50);

    return () => {
      if (canNotGetCookies != null && !canNotGetCookies) {
        clearInterval(interval);
      }
    };
  }, []);

  return canNotGetCookies;
};

export default use3PCookieDisabled;
